// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-history{min-width:240px}.session-history .session-history-form{text-align:right}
`, "",{"version":3,"sources":["webpack://./app/_react_/components/session-history/styles.scss"],"names":[],"mappings":"AAAA,iBACI,eAAgB,CADpB,uCAIQ,gBAAiB","sourcesContent":[".session-history {\n    min-width: 240px;\n\n    .session-history-form {\n        text-align: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
